import type { AxiosRequestConfig } from 'axios';

import { getValidAccessToken } from '@/utils/refreshTokenUtils';

export const gatewayInterceptor = async (config: AxiosRequestConfig) => {
  const headers = config.headers || {};
  const token = await getValidAccessToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { ...config, headers };
};
